import {Modal} from 'components/base-modal/Modal'
import {forwardRef, useImperativeHandle, useState} from 'react'
import feathers from 'utility/client'

const initialProperties = {
  name: '',
  rotationInterval: 30
}

export const Group = forwardRef((props, ref) => {
  const {
    ModalProps = {},
    onCreated = () => {}
  } = props
  const [visible, setVisible] = useState(false)
  const [data, setData] = useState({})
  const [properties, setProperties] = useState(initialProperties)

  useImperativeHandle(ref, () => ({
    show: _data => {
      setData(_data)
      setVisible(true)
    }
  }))

  const handleClose = () => {
    setData({})
    setProperties(initialProperties)
    setVisible(false)
  }

  const handleSave = () => {
    const payload = {
      ...data,
      ...properties
    }

    feathers
      .service('group')
      .create(payload)
      .then(response => onCreated(response))
      .catch(console.error)

    handleClose()
  }

  return (
    <Modal
      open={visible}
      onClose={handleClose}
      center
      title="Add Group"
      confirmTitle="Save Group"
      cancelTitle="Cancel"
      onCancel={handleClose}
      onConfirm={handleSave}
      {...ModalProps}
    >
      <div className="form-group">
        <label>Group Name</label>
        <input
          type="text"
          value={properties.name}
          onChange={e => setProperties({...properties, name: e.target.value})}
          className="form-control"
          placeholder="Group name"
        />
      </div>
      <div className="form-group">
        <label>Rotation interval</label>
        <input
          type="number"
          value={properties.rotationInterval}
          onChange={e => setProperties({...properties, rotationInterval: Number(e.target.value)})}
          className="form-control"
          min={5}
          placeholder="Minutes"
        />
      </div>
    </Modal>
  )
})
